import React from 'react';
import './Wrapper.styles.scss';

const Wrapper = ({ children, className }) => (
  <div className={`wrapper ${className || ''}`}>{children}</div>
);

export default Wrapper;
